import { useUser } from "@/queries/user/useUser";
import { Navigate } from "react-router";
import LoadingSection from "../LoadingSection";
import { UserStatus } from "@/api/SolarCloudApi";
import { useProfileContext } from "@/contexts/ProfileContext";

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { data: user, isLoading } = useUser();
  const { isAuthenticationLoading } = useProfileContext();
  if (isAuthenticationLoading || isLoading) {
    return <LoadingSection />;
  }

  if (!user) {
    console.log("No user found, redirecting to /login");
    return <Navigate to="/login" replace />;
  }

  if (
    // user.status === UserStatus.VERIFIED ||
    user.status === UserStatus.UNVERIFIED
  ) {
    return <Navigate to="/buypanels" replace />;
  }

  return <>{children}</>;
};
